import { Navigate, Outlet, useOutletContext } from 'react-router-dom'

import { Box, Spinner } from '@factorialco/deprecated-design-system'
import { AvailableModules } from 'generated/featureDefinitions'
import { ProfileOverviewDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import { useStrictParams } from 'modules/core/hooks/useStrictParams'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import { RouteContext } from 'modules/employees/lib/types'
import OverviewInformation from 'modules/profile/components/OverviewInformation'

const ProfileOverviewPage = () => {
  const { navigation } = useNavigation()

  const { id: routeId } = useStrictParams<'id'>()
  const { employee: currentEmployee, company } = useCurrentSession()

  const context = useOutletContext<RouteContext>()
  const canSeeOverview = context.canSeeOverview

  const id = routeId ?? currentEmployee.id

  const employeeId = String(id)
  const { data, loading } = useQuery(ProfileOverviewDocument, {
    variables: {
      companyId: company.id,
      employeeId,
      moduleIds: [
        AvailableModules.timeoff,
        AvailableModules.shift_management,
        AvailableModules.projects,
        AvailableModules.time_tracking,
        AvailableModules.trainings,
        AvailableModules.review_process,
        AvailableModules.goals,
        AvailableModules.expenses,
      ],
    },
  })

  useEffect(() => {
    track(trackingEvents.profile.goToEmployeeProfileOverview)
  }, [])

  if (loading) {
    return (
      <Box height="full" alignItems="center" justifyContent="center">
        <Spinner />
      </Box>
    )
  }

  if (data && canSeeOverview) {
    return (
      <>
        <OverviewInformation data={data} />
        <Outlet context={context} />
      </>
    )
  }

  return <Navigate to={navigation.employees.id.fullPath({ id })} />
}

export default ProfileOverviewPage
